// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"938aa06e","240":"96dd3594","455":"3641d855","977":"b292ad65"}[chunkId] + ".chunk.js";
};